import { render } from "./Settings.vue?vue&type=template&id=3f63a4a1&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=3f63a4a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f63a4a1"]])

export default __exports__